// @flow
import type { ReduxState } from '../../types';
export const getCurrentTime = (state: ReduxState) => state.timer;
